import { usePropertyIsForeclosure } from '../../../queries/PropertyFields/NonRentalFlagFields';
import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { ApplicationQuestionReviewItem } from '../../components/ApplicationQuestionReviewItem';

interface ForeclosureProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const Foreclosure: React.FC<ForeclosureProps> = ({ propertyGuid, required = false, isReview = false }) => {
    const label = 'Was the seller HUD, Bank, or other institutional foreclosure?';
    const [isForeclosure, set_isForeclosure] = usePropertyIsForeclosure(propertyGuid);

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        switch (e.itemData?.id.toLowerCase()) {
            case 'yes':
                set_isForeclosure(true);
                return;
            case 'no':
                set_isForeclosure(false);
                return;
            default:
                return;
        }
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={isForeclosure ? 'Yes' : 'No'}
                />
            ) : (
                <YesNoToggleButton
                    id='toggleButtonForeclosure'
                    value={isForeclosure}
                    onItemClick={toggleButtonYesNoClick}
                    width='230px'
                    height='40px'
                    required={required}
                    requiredMessage='Foreclosure required'
                    label={label}
                    labelSize={ToggleButtonLabelSize.Medium}
                />
            )}
        </>
    );
};
